<template>
    <div>
        <centrifuge/>
    </div>
</template>

<script>
import centrifuge from "@/components/3d/centrifuge.vue"
export default {
    components:{
        centrifuge
    }
}
</script>

<style>

</style>